Devuelve los detalles públicos de una campaña específica de la organización autenticada.

## Qué entrega este endpoint

- identidad pública de la campaña;
- estado y tipo de campaña;
- configuración operativa principal, como concurrencia y retries;
- contadores de progreso y totales resumidos;
- referencias públicas de proveedor, agente y SIP trunk cuando existan.

<ApiCodeExamples exampleId="campaignDetail" />

<ApiResponseExamples exampleId="campaignDetail" />

## Campos principales de la respuesta `200`

- `id`: ID de la campaña.
- `canonical_url`: enlace canónico de la campaña en la app Contact-Tel.
- `created_by_id`, `created_by_name`: referencia del usuario creador.
- `ai_agent_provider_id`, `ai_agent_id`, `sip_trunk_id`: referencias públicas ligadas a la configuración.
- `ai_agent_provider_name`, `ai_agent_name`, `sip_trunk_name`: etiquetas visibles de recursos relacionados.
- `status_reason`: código público sanitizado para estados especiales.
- `schedule`: agenda operativa configurada para la campaña.
- `transfer_target_type`, `transfer_target_id`, `transfer_target_name`, `transfer_target_extension`: destino público de transferencia cuando aplique.
- `ivr_dtmf_map`: mapa DTMF configurado para campañas Reverse IVR.
- `ai_billed_seconds`, `ai_gross_billed_seconds`, `ai_refunded_seconds`: consumo de IA líquido, bruto y estornado.
- `telephony_billed_seconds`, `telephony_gross_billed_seconds`, `telephony_refunded_seconds`: consumo de telefonía líquido, bruto y estornado.
- `conversion_rate`: tasa pública de conversión sobre llamadas elegibles.

## Referencia de opciones

- `status`: `draft` aún no está lista; `processing` prepara/importa contactos; `ready` puede iniciar; `active` está en ejecución; `paused` está pausada; `completed` terminó; `cancelled` fue cancelada.
- `status_reason`: `import_failed` indica bloqueo por importación; `config_error` indica bloqueo por configuración; `paused` es pausa operacional normal; `null` significa sin motivo público adicional.
- `campaign_type`: `ai` es campaña con agente de IA; `reverse_ivr` es campaña de URA reversa.
- `ai_agent_provider_type`: `cloud` es proveedor cloud; `asterisk` es Asterisk/SIP local; `sip` es proveedor SIP externo.
- `transfer_target_type`: `user` transfiere a usuario/operador específico; `group` transfiere a grupo de atención; `null` significa sin destino de transferencia configurado.
- `import_status`: `idle`, `processing`, `completed` o `failed`.

## Cuándo usar este endpoint

- consultar una campaña específica a partir del `id` obtenido en la lista;
- sincronizar estado/configuración pública en sistemas externos;
- validar detalles operativos de una campaña sin abrir la interfaz del producto.
